"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numberOfValues = exports.sumOfElements = exports.isNil = void 0;

var sumOfElements = function sumOfElements(elements, expectedSum) {
  if (!elements) return;
  var sum = elements.reduce(function (a, b) {
    return a + b;
  }, 0);
  if (sum !== expectedSum) return new Error("The sum of values should be ".concat(expectedSum));
};

exports.sumOfElements = sumOfElements;

var numberOfValues = function numberOfValues(elements, expectedCount) {
  if (!elements) return;

  if (elements.length !== expectedCount) {
    return new Error("Expected ".concat(expectedCount, " values, found ").concat(elements.length, "!"));
  }
};

exports.numberOfValues = numberOfValues;

var isNil = function isNil(value) {
  return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0 ? true : false);
};

exports.isNil = isNil;